<template>
  <v-app> 
    <v-navigation-drawer class="d-flex d-sm-none" 
      v-model="drawer"
      absolute color="grey lighten-2"
      temporary
    >
      <v-list>
        <v-list-item v-for="item in nav_items" link :to="item.link" :key="item.name">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t(item.name) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar class="pb-0 mb-0 d-flex d-sm-none" dark color="#15283D" height="180px">
      <v-row>
        <v-col></v-col>
        <v-col cols=8>
          <v-row justify="center">
            <v-img src="./assets/logo_2.png" :width="mobile_img_width" class="ma-0 pa-0 mx-6">
              <v-row class="fill-height" align="center">
                <v-btn block text color="transparent" to="/"></v-btn>
              </v-row>
            </v-img>
          </v-row>
          <v-row justify="center">
            <v-img src="./assets/logo_3.png" :width="mobile_img_width" class="mx-6"></v-img>
          </v-row>
          <v-row justify="space-between">
            <v-btn class="ml-2" icon to="/company-access">
              <v-avatar size=70>
                <v-img src="./assets/location.png"></v-img>
              </v-avatar>
            </v-btn>
            <switch-language />
            <v-btn
              href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAxOTE5NjE4Ng==&scene=124#wechat_redirect"
              target="_blank"
              class="ml-2"
              icon
            >
              <v-icon size=35 color="green">mdi-wechat</v-icon>
            </v-btn>
            <v-btn href="mailto:suzhou@trans-cosmos.com.cn?subject=Contact (HP)" class="ml-2" icon>
              <v-icon size=35>mdi-email</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col>
          <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-app-bar app color="#0F1D2D" dark class="d-none d-sm-flex" ref="appbar">
      <v-container >
        <v-row align="center" justify="space-between" >
          <v-spacer></v-spacer>
          <div class="d-flex align-center">
            <!--平板-->
            <v-img src="./assets/logo_2.png" max-width=120 class="ma-0 pa-0 d-none d-sm-flex d-lg-none">
              <v-row class="fill-height" align="center">
                <v-btn block text color="transparent" to="/"></v-btn>
              </v-row>
            </v-img>
             <!--电脑-->
            <v-img src="./assets/logo_2.png" max-width=160 class="ma-0 pa-0 d-none d-lg-flex">
              <v-row class="fill-height" align="center">
                <v-btn block text color="transparent" to="/"></v-btn>
              </v-row>
            </v-img>
            <!--平板-->
            <v-img class="ma-0 pa-0 d-none d-sm-flex d-lg-none"
              src="./assets/logo_3.png" max-width=120
            ></v-img>
            <!--电脑-->
            <v-img class="ma-0 pa-0 d-none d-lg-flex"
              src="./assets/logo_3.png" max-width=200
            ></v-img>
          </div>
          <v-spacer class="d-sm-none d-md-flex"></v-spacer>
          <v-btn v-for="item in filter(nav_items)" :to="item.link" text :key="item.name" class="mx-0 px-1">{{ $t(item.name) }}</v-btn>
          <v-btn class="ml-1" icon small to="/company-access">
            <v-avatar>
              <v-img src="./assets/location.png"></v-img>
            </v-avatar>
          </v-btn>
          <switch-language />
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
             <v-btn
                class="ml-1" icon small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="green">mdi-wechat</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-img max-width="160px"  src="./assets/qrcode.jpg"></v-img>
            </v-list>
          </v-menu>
        <v-btn href="mailto:suzhou@trans-cosmos.com.cn?subject=Contact (HP)" class="ml-1" icon small>
        <v-icon>mdi-email</v-icon>
      </v-btn>
        <v-spacer></v-spacer>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-content :class='isMobile?"py-0":""'>
      <router-view></router-view>
    </v-content>
    <!-- 底部 公司简介 友情链接 标志-->
    <v-footer color="#15283D" id="contact">
      <v-container class="white--text">
        <v-row>
          <v-col cols="2"></v-col>
          <v-col cols="12" lg="8">
            <v-row :no-gutters="small">
              <v-col :cols='isMobile?12:false'>
                <v-card to="/company-overview" flat color="transparent" :class="footer_card_class">
                  <v-card-subtitle :class="footer_card_subtitle">{{ $t('footer.companyTitle') }}</v-card-subtitle>
                  <v-card-text :class="footer_card_text">{{ $t('footer.companyContent') }}</v-card-text>
                </v-card>
              </v-col>
              <v-divider vertical color="white" class="my-12 d-none d-sm-flex" ></v-divider>
              <v-col :cols='isMobile?12:5'>
                <v-card flat color="transparent" :class="footer_card_class" >
                  <v-card-subtitle :class="footer_card_subtitle">{{ $t('footer.friendLinkTitle') }}</v-card-subtitle>
                  <v-card-text :class="footer_card_text">
                    <li
                      class="pb-4"
                      style="list-style-type:none"
                      v-for="item in $t('footer.friendLinks')"
                      :key="item.name"
                    >
                      <a
                        target="_blank"
                        style="text-decoration:none;color:white"
                        :href="item.url"
                      >{{ item.name }}</a>
                    </li>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-img width="200"
                    class="mt-4 d-none d-sm-flex"
                    src="./assets/bottom.jpg"
                  ></v-img>
                  <v-img
                    class="mt-4 d-flex d-sm-none"
                    src="./assets/bottom.jpg"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-4 text-center white--text overline" cols="12">
                <a
                  style="text-decoration:none;color:white"
                  href="http://www.beian.miit.gov.cn/"
                  target="_blank"
                >©2019-2026 苏州大宇宙信息创造有限公司 版权所有 苏ICP备17023330号-1</a>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2"></v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-bottom-navigation app class="d-flex d-sm-none">
      <v-row>
        <v-col>
          <v-btn block href="tel:51286665570">
            <v-icon large color="green">mdi-phone</v-icon>
          </v-btn>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col>
          <v-btn block href="mailto:suzhou@trans-cosmos.com.cn?subject=Contact (HP)">
            <v-icon large color="red">mdi-email</v-icon>
          </v-btn>
        </v-col>
      </v-row>
  </v-bottom-navigation>
  </v-app>
  
</template>
<script>
import SwitchLanguage from "./components/SwitchLanguage.vue";

export default {
  components: {
    "switch-language": SwitchLanguage
  },
  data: () => ({
    small: false,
    isMobile: false,
    drawer: null,
    nav_items: [{"icon":"mdi-card-account-phone","name":"service.title","link":"/service"},
                {"icon":"mdi-file-document-edit","name":"solution.title","link":"/solution"},
                {"icon":"mdi-account-group","name":"recruit.title","link":"/recruit"},
                {"icon":"mdi-home-city","name":"about.about","link":"/company"},
                {"icon":"mdi-email","name":"contact.contact","link":"/#contact"}]
  }),
  methods: {
    filter: function(){
      if(!this.isMobile){
        return this.nav_items.filter((item,index)=>index<4);
      }
      return this.nav_items;
    }
  },
  computed: {
    footer_card_class: function(){
      var footer_card_class = "white--text mx-auto ";
      if(this.isMobile){
        footer_card_class += " text-center";
      }
      return footer_card_class;
    },
    footer_card_subtitle: function(){
      if(this.isMobile){
        return "white--text body-1";
      }
      return "white--text";
    },
    footer_card_text: function(){
      if(this.isMobile){
        return "white--text body-1";
      }
      return "white--text caption";
    },
    mobile_img_width: function(){
      return window.innerWidth - 50;
    }
  },
  mounted() {
    this.small = this.$vuetify.breakpoint.lgAndDown;
    this.isMobile = this.$vuetify.breakpoint.xs;
    this.$refs.appbar.$el.getElementsByClassName("v-toolbar__content")[0].style["width"]="100%"
  }
};
</script>

<style lang="scss">
// @import url("https://fonts.googleapis.com/css?family=Questrial");

.application {
  font-family:  "FangSong";
}
</style>